import { type HTMLAttributes, forwardRef } from 'react'
import { emptySlotVariants } from './EmptySlot.variants'

export interface EmptySlotProps extends Omit<HTMLAttributes<HTMLDivElement>, 'style'> {
  width?: number
  height?: number
  variant?: 'dashed' | 'solid'
}

export const EmptySlot = forwardRef<HTMLDivElement, EmptySlotProps>(
  ({ 
    width = 72, 
    height = 82, 
    variant = 'dashed',
    className, 
    ...props 
  }, ref) => {
    return (
      <div
        className={emptySlotVariants({ variant, className })}
        ref={ref}
        style={{ 
          width: `${width}px`, 
          height: `${height}px`
        }}
        {...props}
      />
    )
  }
)

EmptySlot.displayName = 'EmptySlot'